import ImageWrapper from "./ImageWrapper";
import logo from "../assets/img/tomov-logo-white.png";
import Icon from "./Icon";
import { footer } from "../utils/menus";

function Footer() {
  return (
    <>
      <div className="py-20 mt-20 bg-brand">
        <div className="page__width gap-16 w-full flex flex-col lg:flex-row items-center lg:items-start justify-center">
          <div className="flex flex-col w-1/2 mx-auto lg:mx-0 lg:w-1/6 items-start">
            <ImageWrapper src={logo} className="w-full fill-white" alt="Logo" />
            <div className="w-full mt-8 flex items-center justify-center gap-8">
              <a
                href="https://www.facebook.com/profile.php?id=100033197096470/"
                target="_blank"
              >
                <Icon name="facebook" className="w-6 h-6 text-white" />
              </a>
              <a
                href="https://www.instagram.com/tomov_dentalclinic/"
                target="_blank"
              >
                <Icon name="instagram" className="w-6 h-6 text-white" />
              </a>
            </div>
          </div>

          {Object.keys(footer).map((key) => {
            return (
              <div
                key={key}
                className="w-full lg:w-1/12 flex flex-col items-center text-center lg:text-start lg:items-start"
              >
                <h3 className="text-white text-xl font-forum uppercase mb-2">
                  {key}
                </h3>
                <ul>
                  {footer[key].map((link, i) => {
                    return (
                      <li key={i} className="my-2 text-white text-sm">
                        <a key={i} className="hover:underline" href={link.href}>
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
          <div className="w-full lg:w-1/6 flex flex-col items-center text-center lg:text-start lg:items-start">
            <h3 className="text-white text-xl font-forum uppercase mb-2">
              Работно време
            </h3>
            <ul>
              <li className="my-2 text-white text-sm">
                <b>Понеделник - Петък </b>
                <br />
                09:00 - 18:00
              </li>
              <li className="my-2 text-white text-sm">
                <b>Събота - Неделя</b>
                <br />
                Почивен ден
              </li>
            </ul>
          </div>
          <div className="w-full lg:w-1/6 flex flex-col items-center text-center lg:text-start lg:items-start">
            <h3 className="text-white text-xl font-forum uppercase mb-2">
              Контакти
            </h3>
            <ul>
              <li className="my-4 text-white text-base">
                <a
                  className="hover:underline flex items-center gap-2"
                  href="mailto:tomov.dentalclinic@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon name="email" className="w-6 h-6 text-white" />
                  tomov.dentalclinic
                </a>
              </li>
              <li className="my-4 text-white text-base">
                <a
                  className="hover:underline flex items-center gap-2"
                  href="tel:088 528 5757"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon name="phone" className="w-6 h-6 text-white" />
                  088 528 5757
                </a>
              </li>
              <li className="my-4 text-white text-base">
                <a
                  className="hover:underline flex items-center gap-2"
                  href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon name="location" className="w-6 h-6 text-white" />
                  ul.Opalchenska 94
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full bg-brand">
        <div className="flex flex-col lg:flex-row items-center justify-between page__width pb-4">
          <p className="text-sm mb-2 lg:mb-0 text-white">
            &copy; Tomov Dental {new Date().getFullYear()} | Всички права
            запазени
          </p>
          <p className="text-sm text-white">
            Дизайн и изработка от{" "}
            <a
              href="https://cristiantirotta.com"
              target="_blank"
              rel="noreferrer"
              className="font-semibold underline"
            >
              TirottaWeb
            </a>
            ️💙
          </p>
        </div>
      </div>
    </>
  );
}

export default Footer;
